<template>
    <a :href="logolink" target="_blank">
        <!-- <img :src="logoUrl" alt="" class="logo">
		<img :src="logourl1" alt="" class="logo1"> -->
        <img :src="logoUrl" alt="" class="logo">
    </a>
</template>

<script>
    export default {
        name:'Logo',
        props:{
            logolink:String
        },
        data(){
            return {
                logoUrl:'',
                logourl1:''
            }
        },
        created(){
            this.logoUrl = "/images/logo.png?v="+this.$version;
            this.logourl1="/images/logo1.png?v="+this.$version;
        }
    }
</script>

<style  scoped>
    @media screen and (max-width:768px){
        .logo{
            position: relative;
            margin-top: 20px;
            left: 10px;
            width: 68%;
            height: auto;
            border:none;
        }
    }
    @media screen and (min-width:768px){
        .logo{
            position: absolute;
            top: 20px;
            left: 10px;
            width: 520px;
            height: auto;
            border:none;
        }
    }
</style>